import {Link} from "react-router-dom";
import {Breadcrumb} from "antd";
import {DashboardWrapper} from "../../../../../layouts/dashboard-wrapper";
import {StyledPageHeader} from "../../../../../styles/dashboard/calls/calls";
import {useGoogleCalendarConnection} from "../../../../../react-query-hooks/connect-calendar/useGoogleCalendarConnection";
import {
  StyledAutomationsPageContent,
  StyledIntegrationDetailCard,
  StyledIntegrationDetailHeader,
  StyledIntegrationDetailLayout,
} from "../../automations.style";
import {GoogleCalenderIcon} from "../../icons/google-calender-icon";
import {IntegrationConnectionVisual} from "../components/IntegrationConnectionVisual";
import {IntegrationConnectPanel} from "../components/IntegrationConnectPanel";

const CALENDAR_BULLET_POINTS = [
  "Coachli reads your calendar so clients only see slots you're actually free",
  "New bookings and events are added to your calendar instantly",
  "No more double bookings or clashing appointments",
  "We only access your free/busy status. Your event details stay private",
];

export function GoogleCalendarIntegrationPage() {
  const {isConnected, connect, disconnect, isConnecting, isDisconnecting} =
    useGoogleCalendarConnection();

  return (
    <DashboardWrapper pageTitle="Google calendar">
      <StyledPageHeader>Automations</StyledPageHeader>
      <StyledAutomationsPageContent>
        <StyledIntegrationDetailHeader>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/automations?tab=integrations">Integrations</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Google calendar</Breadcrumb.Item>
          </Breadcrumb>
        </StyledIntegrationDetailHeader>

        <StyledIntegrationDetailCard>
          <StyledIntegrationDetailLayout>
            <IntegrationConnectionVisual integrationIcon={<GoogleCalenderIcon />} />
            <IntegrationConnectPanel
              title="Your schedule, always in sync"
              bulletPoints={CALENDAR_BULLET_POINTS}
              connectLabel="Connect Google calendar"
              disconnectLabel="Disconnect Google calendar"
              isConnected={isConnected}
              onConnect={connect}
              onDisconnect={disconnect}
              isConnectLoading={isConnecting}
              isDisconnectLoading={isDisconnecting}
            />
          </StyledIntegrationDetailLayout>
        </StyledIntegrationDetailCard>
      </StyledAutomationsPageContent>
    </DashboardWrapper>
  );
}
